import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function ReportList() {
  const navigate = useNavigate();
  const location = useLocation();

  const reports = [
    {
      id: 1,
      title: 'Executive Summary Dashboard',
      description: 'Tổng quan điều hành về quản lý rủi ro mô hình, bao gồm thống kê mô hình, nhiệm vụ, phát hiện mở và lịch trình sắp tới',
      path: '/reports/executive-dashboard',
      icon: 'bi-speedometer2',
      color: 'primary'
    },
    {
      id: 2,
      title: 'Executive Summary',
      description: 'Báo cáo tổng hợp điều hành chi tiết với phân tích theo danh mục, giai đoạn, trạng thái xác thực và mức độ rủi ro',
      path: '/reports/executive-summary',
      icon: 'bi-bar-chart-line',
      color: 'info'
    },
    {
      id: 3,
      title: 'Model Distribution',
      description: 'Phân tích phân phối mô hình theo các giai đoạn, nhà cung cấp, loại rủi ro và mức độ trưởng thành',
      path: '/reports/model-distribution',
      icon: 'bi-pie-chart',
      color: 'success'
    },
    {
      id: 4,
      title: 'Finding Overview',
      description: 'Tổng quan về các phát hiện, phân tích theo mức độ nghiêm trọng, xu hướng theo thời gian và phân loại theo mô hình',
      path: '/reports/finding-overview',
      icon: 'bi-exclamation-diamond',
      color: 'warning'
    },
    {
      id: 5,
      title: 'Báo cáo tổng hợp các trường hợp cảnh báo sớm',
      description: 'Cung cấp danh sách toàn bộ các trường hợp cảnh báo sớm trên hệ thống, bao gồm các nội dung về loại khách hàng, trạng thái, tổng điểm, mức độ rủi ro, ngày khởi tạo, người khởi tạo, lịch sử quá trình và chi tiết các điểm chi tiêu cảnh báo sớm',
      path: '/reports/summary',
      icon: 'bi-file-earmark-text',
      color: 'secondary'
    },
    {
      id: 6,
      title: 'Báo cáo các trường hợp cảnh báo sớm rủi ro cao',
      description: 'Cung cấp danh sách các trường hợp cảnh báo sớm rủi ro cao trên hệ thống, bao gồm các nội dung về loại khách hàng, trạng thái, tổng điểm, ngày khởi tạo, người khởi tạo, lịch sử quá trình và chi tiết các điểm chi tiêu cảnh báo sớm',
      path: '/reports/high-risk',
      icon: 'bi-exclamation-triangle-fill',
      color: 'danger'
    },
    {
      id: 7,
      title: 'Báo cáo các trường hợp cảnh báo sớm rủi ro trung bình',
      description: 'Cung cấp danh sách các trường hợp cảnh báo sớm rủi ro trung bình trên hệ thống, bao gồm các nội dung về loại khách hàng, trạng thái, tổng điểm, ngày khởi tạo, người khởi tạo, lịch sử quá trình và chi tiết các điểm chi tiêu cảnh báo sớm',
      path: '/reports/medium-risk',
      icon: 'bi-exclamation-circle',
      color: 'warning'
    },
    {
      id: 8,
      title: 'Báo cáo các trường hợp cảnh báo sớm rủi ro thấp',
      description: 'Cung cấp danh sách các trường hợp cảnh báo sớm rủi ro thấp trên hệ thống, bao gồm các nội dung về loại khách hàng, tổng điểm, ngày khởi tạo, người khởi tạo, lịch sử quá trình và nhận xét, chi tiết các điểm chi tiêu cảnh báo sớm',
      path: '/reports/low-risk',
      icon: 'bi-info-circle',
      color: 'success'
    },
    {
      id: 9,
      title: 'Báo cáo các trường hợp cảnh báo sớm đã đóng',
      description: 'Cung cấp danh sách các trường hợp cảnh báo sớm đã đóng trên hệ thống, bao gồm các nội dung về loại khách hàng, tổng điểm, ngày khởi tạo, người khởi tạo, lịch sử quá trình và nhận xét, chi tiết các điểm chi tiêu cảnh báo sớm',
      path: '/reports/resolved',
      icon: 'bi-check-circle',
      color: 'secondary'
    },
    {
      id: 10,
      title: 'Báo cáo các mô hình cảnh báo sớm',
      description: 'Cung cấp danh sách các mô hình cảnh báo sớm sử dụng trên hệ thống, bao gồm tên các mô hình, các chỉ tiêu thuộc mô hình, trọng số và ngưỡng cảnh báo, trạng thái các mô hình',
      path: '/reports/models',
      icon: 'bi-diagram-3',
      color: 'primary'
    }
  ];

  const handleReportClick = (path) => {
    navigate(path);
  };

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Back button */}
        <div className="col-12 mb-3">
          <button className="btn btn-outline-secondary" onClick={handleBack}>
            <i className="bi bi-arrow-left me-2"></i>
            Về Dashboard
          </button>
        </div>

        {/* Page header */}
        <div className="col-12 mb-4">
          <h2>
            <i className="bi bi-file-earmark-text me-2"></i>
            Danh sách các báo cáo cần báo sớm
          </h2>
          <p className="text-muted">
            Chọn loại báo cáo để xem chi tiết
          </p>
        </div>

        {/* Report list */}
        <div className="col-12">
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th style={{ width: '80px' }}>STT</th>
                  <th>TÊN BÁO CÁO</th>
                  <th>MÔ TẢ</th>
                  <th style={{ width: '100px' }}></th>
                </tr>
              </thead>
              <tbody>
                {reports.map((report) => (
                  <tr 
                    key={report.id}
                    onClick={() => handleReportClick(report.path)}
                    style={{ cursor: 'pointer' }}
                    className="report-row"
                  >
                    <td className="text-center">
                      <div className={`badge bg-${report.color || 'primary'} rounded-circle`} style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem' }}>
                        {report.id}
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <i className={`${report.icon} text-${report.color || 'primary'} me-2`} style={{ fontSize: '1.5rem' }}></i>
                        <strong>{report.title}</strong>
                      </div>
                    </td>
                    <td>
                      <small className="text-muted">{report.description}</small>
                    </td>
                    <td className="text-end">
                      <button className="btn btn-sm btn-outline-primary">
                        <i className="bi bi-arrow-right"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Export button */}
        <div className="col-12 mt-4">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">
                <i className="bi bi-download me-2"></i>
                ĐĂNG XUẤT
              </h5>
              <p className="text-muted mb-3">Tải xuất báo cáo tổng hợp tất cả loại</p>
              <button className="btn btn-success">
                <i className="bi bi-file-earmark-excel me-2"></i>
                Xuất Excel
              </button>
              <button className="btn btn-danger ms-2">
                <i className="bi bi-file-earmark-pdf me-2"></i>
                Xuất PDF
              </button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .report-row:hover {
          background-color: #f8f9fa;
          transform: translateY(-2px);
          transition: all 0.2s;
        }
        
        .report-row:hover td {
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
      `}</style>
    </div>
  );
}

export default ReportList;
